<template>
    <ds-modal
        :is-open="isOpen"
        show-close
        :title="$t('funnel.copy.via.ContentPublishing.title')"
        size="sm"
        class="copy-via-content-modal"
        @close="closeCopyPublishing"
    >
        <div class="copy-content-help-text ">
            {{ $t('funnel.content.publishing.copy.description') }}
            <ds-icon name="help-circle" class="help-circle-icon" />
        </div>

        <ds-input-field
            v-model="packagePrefix"
            :label="$t('funnel.content.publishing.package.prefix.label')"
            :invalid="showErrorMessage"
            submitted
            data-qa="prefix-input"
        />
        <div class="button-row-copy">
            <ds-filled-button
                id="copyContentPublishing-button"
                :loading="isLoadingContentPublishing"
                data-qa="copy-content-publishing-button"
                @click="copyViaContentPublishing"
            >
                {{ $t('funnel.content.publishing.copy.button') }}
            </ds-filled-button>
            <ds-text-button
                data-qa="cancel-copyContentPublishing-button"
                @click="closeCopyPublishing"
            >
                {{ $t('global.cancel') }}
            </ds-text-button>
        </div>
        <ds-inline-alert
            v-if="showErrorMessage"
            leading-icon
            type="warning"
            class="copy-content-alert-message"
        >
            {{ messageResultText }}
        </ds-inline-alert>
    </ds-modal>
</template>

<script>
import { copyContent } from './copy.via.content.publishing.api';
import { utils } from '../../utils/legacy-utils';

export default {
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        funnelId: {
            type: Number,
            default: 0,
        },
        funnelName: {
            type: String,
            required: true,
        },
    },
    emits: ['close-copy-publishing', 'save-automation'],
    data() {
        return {
            packagePrefix: '',
            copyContentResult: [],
            messageResultText: '',
            showErrorMessage: false,
            isLoadingContentPublishing: false,
        };
    },

    methods: {
        async copyViaContentPublishing() {
            try {
                this.isLoadingContentPublishing = true;

                this.$emit('save-automation');

                this.copyContentResult = await copyContent(this.funnelId, this.funnelName, this.packagePrefix);

                if (this.copyContentResult.status === this.$t('funnel.edit.ok')) {
                    if (this.copyContentResult.warnings.length > 0) {
                        this.showErrorMessage = true;
                        this.messageResultText = utils.parseHtmlTagsToString(this.copyContentResult.warnings);
                    } else {
                        this.closeCopyPublishing();
                        this.$toast({ message: this.$t('funnel.content.publishing.copy.submit.success') });
                    }
                } else {
                    this.showErrorMessage = true;
                    this.messageResultText = utils.parseHtmlTagsToString(this.copyContentResult.errorMessage);
                }
                this.isLoadingContentPublishing = false;
            } catch (error) {
                this.$error({ message: this.$t('funnel.content.publishing.copy.submit.error') });
            }
        },

        closeCopyPublishing() {
            this.$emit('close-copy-publishing');
        },
    },
};
</script>

<style scoped>
.copy-content-help-text {
    font-weight: 500;
    margin-bottom: 1rem;
    display: inline-flex;
    align-items: center;
    margin-top: 0.3em;
}

.help-circle-icon {
    padding: 4px;
    color: #666666;
}

div.button-row-copy {
    display: flex;
    justify-content: flex-start;
}

#copyContentPublishing-button.loading {
    display: block !important;
}

</style>

<style lang="scss">
.inline-alert.copy-content-alert-message.warning > span {
    font-size: 14px;
    line-height: normal;
}

.inline-alert.copy-content-alert-message.warning {
    margin-top: 1.5rem;
}
</style>
